module.exports = __webpack_public_path__ + "img/goldregen-2020-094.da124604.jpg";